import { render } from "./AcceptTermsModal.vue?vue&type=template&id=add818cc&scoped=true"
import script from "./AcceptTermsModal.vue?vue&type=script&lang=js"
export * from "./AcceptTermsModal.vue?vue&type=script&lang=js"

import "./AcceptTermsModal.vue?vue&type=style&index=0&id=add818cc&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add818cc"]])

export default __exports__